
import Vue from 'vue';
import { Button, Modal, Icon } from '@descomplica/vue-components';
import i18n from '@/i18n';
import { TranslateResult } from 'vue-i18n';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';

interface Data {
  isActive: boolean;
  isCopied: boolean;
  timeouts: Array<number>;
}

export default Vue.extend({
  components: {
    Button,
    Modal,
    Icon,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    discipline: {
      type: String,
      required: true,
    },
    notesNumber: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      isActive: this.active,
      isCopied: false,
      timeouts: [] as Array<number>,
    };
  },
  computed: {
    copyFeedback(): TranslateResult {
      return this.isCopied ? i18n.t('linkCopied') : i18n.t('copyLink');
    },
    isPossibleToShare(): boolean {
      return Boolean(navigator.share);
    },
  },
  updated() {
    this.isActive = this.active;
  },
  beforeDestroy() {
    const { clearTimeout } = window;

    this.timeouts.map((timeout) => clearTimeout(timeout));
  },
  methods: {
    updateActive(active: boolean) {
      this.$emit('update:active', active);
    },
    copyHandler(): void {
      this.isCopied = true;
      navigator.clipboard.writeText(this.url);
      this.$emit('linkCopied');

      const { setTimeout } = window;
      this.timeouts.push(
        setTimeout(() => {
          this.isCopied = false;
        }, 2000),
      );
    },
    async shareContent(): Promise<void> {
      await navigator.share({
        title: i18n.t('descomplicaUniversity').toString(),
        text: i18n
          .t('shareNotebookContentTitle', { discipline: this.discipline, url: this.url })
          .toString(),
      });

      Analytics.trackEvent(EVENT_LABELS.notebookInteracted, {
        discipline: this.discipline,
        interaction_type: 'Share Options Clicked',
      });
    },
  },
});
